import { useAppSelector } from 'store'

import { selectReachedAcademicFocus, selectReachedInterest, showCollegeMetrics } from '.'

export const useCanViewMetrics = () => {
  return showCollegeMetrics()
}
export const useSelectReachedInterests = () => useAppSelector((state) => selectReachedInterest(state))
export const useSelectReachedAcademicFocus = () => useAppSelector((state) => selectReachedAcademicFocus(state))
